export const DEFAULT_META_TAG_NAME = {
    description: 'description',
    keywords: 'keywords',
    charset: 'charset',
    author: 'author',
    viewport: 'viewport',
};
export const DEFAULT_HTML_TITLE = '8base App';
